import { actionCreator, checkHttpStatus, jsonApiHeader, showSuccessMessage, showWarningMessage } from "../../downLoadClientList/constants/ApiConstants";
import { DownloadBehaviorsActionTypes, POST_DOWNLOADBEHAVIORSFORRAWDATA, GET_CLIENTSFORBEHAVIORDOWNLOAD, GET_BEHAVIORSBYCLIENTIDS, POST_DOWNLOAD_TARGET_FOR_UPLOADING_RAW_DATA } from '../constants/downloadBehaviorsForRawDataConstant';
import { createRequestAction } from '../../../../../../actions/utilAction';

// Using createRequestAction for GET requests
export const getClientsForBehaviorDownload = createRequestAction(DownloadBehaviorsActionTypes.get_ClientsForBehaviorDownload, GET_CLIENTSFORBEHAVIORDOWNLOAD, 'GET');

export const getBehaviorsByClientIds = (clientIds) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(DownloadBehaviorsActionTypes.get_BehaviorsByClientIds.REQUEST));
    fetch(`${GET_BEHAVIORSBYCLIENTIDS}?clientIds=${clientIds}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(DownloadBehaviorsActionTypes.get_BehaviorsByClientIds.SUCCESS, response));
        } else {
          dispatch(actionCreator(DownloadBehaviorsActionTypes.get_BehaviorsByClientIds.SUCCESS, null));
        }
      })
      .catch(function (error) {
        console.log('error getBehaviorsByClientIds', error);
        dispatch(actionCreator(DownloadBehaviorsActionTypes.get_BehaviorsByClientIds.FAILURE, error));
      });
  };
};

export const downloadBehaviorsForRawData = (requestData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(DownloadBehaviorsActionTypes.post_DownloadBehaviorsForRawData.REQUEST));
    fetch(POST_DOWNLOADBEHAVIORSFORRAWDATA, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(requestData),
    })
      .then(response => {
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'BehaviorRawDataTemplate.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        dispatch(actionCreator(DownloadBehaviorsActionTypes.post_DownloadBehaviorsForRawData.SUCCESS));
      })
      .catch(error => {
        dispatch(actionCreator(DownloadBehaviorsActionTypes.post_DownloadBehaviorsForRawData.FAILURE, error.message));
      });
  };
};

// Keep downloadBehaviorsForRawData as is since it handles file download differently

export const downloadTargetForRawData = (params) => {
  return (dispatch, getState) => {
    let query_params =`?PatientIds=${params.PatientIds}&DomainIds=${params.DomainIds}&ProgramIds=${params.ProgramIds}&
    TargetIds=${params.TargetIds}&IsActivePrograms=${params.IsActivePrograms}&IsActiveTargets=${params.IsActiveTargets}&
    extension=${params.extension}`;
    dispatch(actionCreator(DownloadBehaviorsActionTypes.pst_DownloadTargetForUploadingRawData.REQUEST));
    fetch(`${POST_DOWNLOAD_TARGET_FOR_UPLOADING_RAW_DATA}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName =`CLIENT LIST FOR TARGETS.${params.extension?params.extension:'csv'}`;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(DownloadBehaviorsActionTypes.pst_DownloadTargetForUploadingRawData.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downloadTargetsBehaviors/actions/downloadBehaviorsForRawDataAction.js